"use strict";

(function (Drupal, once) {
  Drupal.behaviors.menu = {
    attach: function attach(context, settings) {
      var menu = document.querySelector('#block-darthome-2021-main-menu');
      if (!menu) {
        return;
      }
      var body = document.body;
      var header = document.querySelector('.header');
      var logoWrapper = document.querySelector('.logo--wrapper');
      var menuTrigger = document.querySelector('.header--wrapper .menu--trigger');
      var mainMenuNav = document.querySelector('.menu--main');
      var forYouMenu = document.querySelector('.menu--resources-for');
      var forYouTrigger = forYouMenu.querySelector('.for-you--trigger');
      var dropdown = document.querySelector('.menu--bg');
      var announcement = document.querySelector('article.announcement');
      var announcementHeight = announcement ? announcement.offsetHeight : 0;
      var animationOffset = 500;
      // Large header breakpoint (desktop header) is 1100px.
      var sizeMq = window.matchMedia('(min-width: 68.75rem)');
      var classes = {
        active: 'js-menu-is-active',
        closing: 'js-menu-is-closing',
        desktop: 'js-is-desktop',
        foryou: 'js-for-you-is-open',
        mobile: 'js-is-mobile',
        open: 'js-menu-is-open',
        processed: 'js-is-processed',
        resizing: 'js-menu-is-resizing',
        submenu: 'js-submenu-is-active',
        tabbing: 'js-menu-is-tabbing'
      };
      var hoverTimeoutId;

      /* Close the menu */
      var menuClosing = function menuClosing() {
        // When the menu is closing, we temporarily add a "closing" class to
        // create a nicer transition/wipe effect rather than text immediately
        // turning black on a Dartmouth green background.
        body.classList.add(classes.closing);
        setTimeout(function () {
          body.classList.remove(classes.closing);
        }, 850);
      };

      /* Toggle the menu Active State */
      var addOpenMenu = function addOpenMenu() {
        // When we hover on an item, add the open class/show the green bg.
        if (!body.classList.contains(classes.open)) {
          body.classList.add(classes.open);
        }
      };
      var removeOpenMenu = function removeOpenMenu() {
        // If we are tabbing, we don't want to hide the BG.
        if (!body.classList.contains(classes.tabbing)) {
          body.classList.remove(classes.open);
          menuClosing();
        }
      };

      /* Toggle the menu Active State */
      var activeMenuToggle = function activeMenuToggle() {
        // When we hover on an item, add the open class/show the green bg.
        if (!body.classList.contains(classes.open)) {
          addOpenMenu();
        } else {
          removeOpenMenu();
        }
      };

      /**
       * Show the submenu on desktop.
       *
       * @param {element} el The element passed from the event listener.
       * @param {element} subMenu The submenu to show.
       */
      var showSubMenuDesktop = function showSubMenuDesktop(el, subMenu) {
        if (!el.classList.contains(classes.active)) {
          var dropdownHeight;
          var ctaStyles;
          var cta = subMenu.parentNode.parentNode.querySelector('.block-cta-tile');

          // The dropdown height is based on the calculated height of the
          // submenu contents.
          if (cta) {
            ctaStyles = window.getComputedStyle(cta);
          }
          if (cta && cta.offsetHeight + parseInt(ctaStyles.getPropertyValue('top')) > subMenu.offsetHeight) {
            dropdownHeight = cta.offsetHeight + parseInt(ctaStyles.getPropertyValue('top'));
          } else {
            dropdownHeight = subMenu.offsetHeight;
          }

          // If an emergency has become active, we must account for its height.
          var emergency = document.querySelector('.emergency-notification');
          var _emergencyHeight = emergency ? emergency.offsetHeight : 0;
          dropdown.style.height = "".concat(dropdownHeight + announcementHeight + _emergencyHeight + 70, "px");
          el.classList.add(classes.active);

          // Make sure the active class remains on the body anytime we add
          // active class to the menu li.
          addOpenMenu();
        }
      };

      /**
       * Hide the submenu on desktop.
       *
       * @param {element} el The element passed from the event listener.
       */
      var hideSubMenuDesktop = function hideSubMenuDesktop(el) {
        if (el.classList.contains(classes.active)) {
          // The default "dropdown" 5px green bar at the top of the header is
          // set in CSS, so we can remove the inline styling.
          el.classList.remove(classes.active);
        }
      };

      /**
       * Hide the submenu on desktop.
       *
       * @param {element} el The element passed from the event listener.
       */
      var hideDropdownDesktop = function hideDropdownDesktop() {
        if (body.classList.contains(classes.open)) {
          // Hide all submenus.
          once('hideAllSubmenus', '.menu-level-0 > .menu-item', menu).forEach(function (el) {
            hideSubMenuDesktop(el);
          });
          hoverTimeoutId = setTimeout(function () {
            // The default "dropdown" 5px green bar at the top of the header is
            // set in CSS, so we can remove the inline styling.
            dropdown.style.removeProperty('height');
            header.style.height = 'auto';
            removeOpenMenu();
            body.classList.remove(classes.open);
            body.classList.remove(classes.tabbing);
          }, animationOffset);
        }
      };

      /* Parent function to handle the desktop hover/focus */
      var menuDesktop = function menuDesktop() {
        // We need to check when we hit the first link to handle reverse tabbing.
        var firstLink = menu.querySelector('.menu-level-0 > .menu-item--expanded:first-child a');

        // The "Hover Trigger" is the top-level menu item, e.g. "Admissions,"
        // "Academics."
        once('menuHoverTriggerListener', '.menu-level-0 > .menu-item', menu).forEach(function (el) {
          // We need to swap so .menu_link_content's .menu comes after .layout.
          var menuLinkContent = el.querySelector('.menu_link_content');
          var menu = menuLinkContent.querySelector('.menu-level-1');
          var layout = menuLinkContent.querySelector('.layout');
          if (menu && layout) {
            menuLinkContent.insertBefore(layout, menu.nextSibling);
          }

          // The submenu is the child menu below the trigger.
          var subMenu = el.querySelector('.menu-level-1');

          // The focus trigger is the link inside the li.
          var focusTrigger = el.querySelector('a:first-child');

          // The last link in the submenu should trigger the submenu close.
          // It's the last child link of the last li in the menu, or the last
          // link in the CTA block.
          var lastLink = el.querySelector('.menu-level-1 > li:last-of-type a');
          if (typeof layout !== 'undefined' && layout !== null) {
            var ctaLink = layout.querySelector('.block-cta-tile a');
            if (typeof ctaLink !== 'undefined' && ctaLink !== null) {
              lastLink = ctaLink;
            }
          }

          // The last two links are not expanded so we need a default.
          if (!el.classList.contains('menu-item--expanded')) {
            lastLink = el;
          }
          once('menuHoverListener', el, context).forEach(function (element) {
            element.addEventListener('mouseenter', function () {
              // This should only fire on desktop, but we still need the
              // listener in case we resize.
              if (body.classList.contains(classes.desktop)) {
                if (element.classList.contains('menu-item--expanded')) {
                  hoverTimeoutId = setTimeout(function () {
                    addOpenMenu();
                    showSubMenuDesktop(element, subMenu);
                  }, animationOffset);
                } else if (element.classList.contains('menu-item')) {
                  // Close the dropdown on mouseenter for non-expanded items.
                  hideDropdownDesktop();
                }
              }
            });

            // Hide current submenu on mouseleave event listener.
            element.addEventListener('mouseleave', function () {
              if (body.classList.contains(classes.desktop)) {
                clearTimeout(hoverTimeoutId);
                if (element.classList.contains('menu-item--expanded')) {
                  hoverTimeoutId = setTimeout(function () {
                    hideSubMenuDesktop(element);
                  }, animationOffset);
                }
              }
            });
          });

          // Hide dropdown when leaving the .header div.
          header.addEventListener('mouseleave', function () {
            if (body.classList.contains(classes.desktop)) {
              hideDropdownDesktop();
            }
          });

          // Ensure dropdown is hidden when mouse is moved to main nav's
          // siblings.
          logoWrapper.addEventListener('mouseenter', function () {
            if (body.classList.contains(classes.desktop)) {
              hideDropdownDesktop();
            }
          });
          forYouMenu.addEventListener('mouseenter', function () {
            if (body.classList.contains(classes.desktop)) {
              hideDropdownDesktop();
            }
          });
          focusTrigger.addEventListener('focus', function (e) {
            tabMenuReset();
            body.classList.add(classes.tabbing);
            if (e.target.parentNode.classList.contains('menu-item--expanded')) {
              addOpenMenu();
              showSubMenuDesktop(el, subMenu);
            } else {
              body.classList.add(classes.closing);
              setTimeout(function () {
                body.classList.remove(classes.closing);
                body.classList.remove(classes.open);
              }, 1000);
            }
          });

          // Handle tabbing in reverse.
          focusTrigger.addEventListener('keydown', function (e) {
            if (e.shiftKey && e.keyCode == 9) {
              if (e.target.parentNode.classList.contains('menu-item--expanded')) {
                hideSubMenuDesktop(el);
              }
            }
          });

          // Handle tabbing the last link in the menu.
          lastLink.addEventListener('keydown', function (e) {
            if (e.keyCode === 9) {
              hideSubMenuDesktop(el);
            }
          });
        });
        firstLink.addEventListener('keydown', function (e) {
          if (e.shiftKey && e.keyCode == 9) {
            body.classList.remove(classes.open);
          }
        });
      };

      /* Parent function to handle the "For You" menu hover */
      var forYouDesktop = function forYouDesktop() {
        var lastLink = forYouMenu.querySelector('li:last-of-type a');
        forYouMenu.addEventListener('mouseenter', function () {
          hoverTimeoutId = setTimeout(function () {
            if (!body.classList.contains(classes.foryou)) {
              body.classList.add(classes.foryou);
            }
          }, animationOffset);
        });
        forYouTrigger.addEventListener('focus', function () {
          if (!body.classList.contains(classes.foryou)) {
            body.classList.add(classes.foryou);
          }
        });
        forYouMenu.addEventListener('mouseleave', function () {
          clearTimeout(hoverTimeoutId);
          hoverTimeoutId = setTimeout(function () {
            if (body.classList.contains(classes.foryou)) {
              body.classList.remove(classes.foryou);
            }
          }, animationOffset);
        });

        // Ensure foryou class removed if mouseenter on forYouMenu siblings.
        logoWrapper.addEventListener('mouseenter', function () {
          clearTimeout(hoverTimeoutId);
          hoverTimeoutId = setTimeout(function () {
            if (body.classList.contains(classes.foryou)) {
              body.classList.remove(classes.foryou);
            }
          }, animationOffset);
        });
        mainMenuNav.addEventListener('mouseenter', function () {
          clearTimeout(hoverTimeoutId);
          hoverTimeoutId = setTimeout(function () {
            if (body.classList.contains(classes.foryou)) {
              body.classList.remove(classes.foryou);
            }
          }, animationOffset);
        });

        // Handle tabbing the last link in the "For You" menu.
        lastLink.addEventListener('keydown', function (e) {
          if (e.keyCode === 9) {
            body.classList.remove(classes.foryou);
          }
        });

        // Handle reverse tabbing from "For You" menu.
        forYouTrigger.addEventListener('keydown', function (e) {
          if (e.shiftKey && e.keyCode == 9) {
            body.classList.remove(classes.foryou);
          }
        });
      };

      /* Show the mobile menu */
      var menuMobileToggle = function menuMobileToggle() {
        var emergency = document.querySelector('.emergency-notification');
        var logo = document.querySelector('.logo--wrapper');
        if (body.classList.contains(classes.open)) {
          var menuElement = menu.querySelector('.menu-level-0');

          // If there is an emergency element active, we need to adjust the top
          // margin on the logo and trigger.
          if (emergency) {
            var _emergencyHeight2 = emergency ? emergency.offsetHeight : 0;
            logo.style.marginTop = "".concat(_emergencyHeight2, "px");
            menuTrigger.style.marginTop = "".concat(_emergencyHeight2, "px");
          }

          // We position the "For You" menu on mobile based on the height +
          // margin of the first-level menu.
          var menuHeight = menuElement.offsetHeight + window.getComputedStyle(menu).marginTop;
          forYouMenu.style.top = "".concat(menuHeight, "px");
          dropdown.style.height = "".concat(announcementHeight + emergencyHeight + 70, "px");
          Drupal.behaviors.dart_utils.body_prevent_scroll();
        } else {
          // If there is an emergency element active, we need to set the margins
          // on the logo and trigger back to normal.
          if (emergency) {
            logo.style.marginTop = '0px';
            menuTrigger.style.marginTop = '0px';
          }
          var activeSubmenu = menu.querySelector(".".concat(classes.active));
          if (activeSubmenu) {
            setTimeout(function () {
              activeSubmenu.classList.remove(classes.active);
            }, animationOffset);
          }

          // If the "For You" menu is open we need to close it specifically.
          // We set the timeout so that the transition happens off screen.
          if (body.classList.contains(classes.foryou)) {
            setTimeout(function () {
              body.classList.remove(classes.foryou);
            }, 1000);
          }
          setTimeout(function () {
            body.classList.remove(classes.open);
            menu.classList.remove(classes.submenu);
            dropdown.style.removeProperty('height');
            removeOpenMenu();
          }, animationOffset);
          Drupal.behaviors.dart_utils.body_prevent_scroll_destroy();
        }
      };

      /**
       * Show the submenu on mobile.
       *
       * @param {element} subMenu The submenu to show.
       */
      var showSubMenuMobile = function showSubMenuMobile(subMenu) {
        if (!subMenu.classList.contains(classes.active)) {
          subMenu.classList.add(classes.active);
          menu.classList.add(classes.submenu);
        }
      };

      /**
       * Hide the submenu on mobile.
       * @param {element} el The element being triggered.
       * @param {boolean} lastMenu If this is the last level of menu.
       */
      var hideSubMenuMobile = function hideSubMenuMobile(el, lastMenu) {
        if (el.classList.contains(classes.active)) {
          el.classList.remove(classes.active);

          // If the last submenu is being hidden we remove the submenu active
          // class.
          if (lastMenu) {
            menu.classList.remove(classes.submenu);
          }
        }
      };

      /**
       * Build and display the mobile breadcrumb.
       * @param {string} title The title for the breadcrumb.
       * @param {element} activeSubMenu The current active submenu.
       * @param {element} subMenuLevel The current submenu level (0 or 1).
       */
      var mobileBreadcrumb = function mobileBreadcrumb(title, activeSubMenu, subMenuLevel) {
        var mobileBreadcrumb = menu.querySelector('.menu--breadcrumb');
        if (!mobileBreadcrumb) {
          return;
        }
        // There can be up to three buttons in the breadcrumb.
        var backButton = mobileBreadcrumb.querySelector('.menu--breadcrumb-back');
        var level0Button = mobileBreadcrumb.querySelector('.menu--breadcrumb-level-0');
        var level1Button = mobileBreadcrumb.querySelector('.menu--breadcrumb-level-1');

        /**
         * Helper function to reset top level nav in mobile.
         */
        var resetTopLevelNav = function resetTopLevelNav() {
          // If we are closing the "For You" menu we do some specific things.
          // Otherwise we use our normal submenu hide function.
          if (activeSubMenu.classList.contains('menu--resources-for')) {
            body.classList.remove(classes.foryou);
            menu.classList.remove(classes.submenu);
          } else {
            hideSubMenuMobile(activeSubMenu, true);
          }

          // If we are jumping back two levels we need to reset the txt.
          if (level1Button) {
            level1Button.textContent = '';
          }
        };

        // If we're on menu level 0, then we update the level 0 button.
        // We also need to check if we're opening "For You."
        if (subMenuLevel.classList.contains('menu-level-0') || subMenuLevel.classList.contains('menu--resources-for')) {
          level0Button.textContent = title;
        }
        if (subMenuLevel.classList.contains('menu-level-1')) {
          // If we are on menu level 1 we need to append the SVG caret to level
          // 0 button.
          level0Button.insertAdjacentHTML('beforeend', "<svg class=\"icon caret\"><use href=\"#caret\"></use></svg>");
          level1Button.textContent = title;

          // We also need to add a listener to the level 0 button: if we go
          // back a level we need to remove the SVG caret.
          level0Button.addEventListener('click', function () {
            var svg = level0Button.querySelector('.icon');
            // We pass "false" here so the breadcrumbs don't fade out.
            hideSubMenuMobile(activeSubMenu, false);
            level1Button.textContent = '';
            level0Button.removeChild(svg);
          });
        }

        // Add event listener to reset top level nav when new focused element
        // (relatedTarget) is moved outside of active submenu.
        if (activeSubMenu.classList.contains(classes.active)) {
          var activeSubMenuChildren = activeSubMenu.querySelector('.menu');
          activeSubMenuChildren.addEventListener('focusout', function (event) {
            if (!activeSubMenuChildren.contains(event.relatedTarget)) {
              resetTopLevelNav();
            }
          });
        }

        // The back button will always reset us to the top-level nav.
        backButton.addEventListener('click', function () {
          resetTopLevelNav();
        });
      };

      /* Handle opening of submenus on mobile */
      var menuMobileSubmenu = function menuMobileSubmenu() {
        var submenuTrigger = menu.querySelectorAll('.submenu--trigger');
        if (!submenuTrigger) {
          return;
        }
        submenuTrigger.forEach(function (el) {
          el.addEventListener('click', function () {
            var subMenuParent = el.closest('.menu-item--expanded');
            var subMenuTxt = el.previousElementSibling.textContent;
            var subMenuLevel = el.closest('ul');
            showSubMenuMobile(subMenuParent);
            // We pass the submenu text, parent, and level to the breadcrumb
            // function.
            mobileBreadcrumb(subMenuTxt, subMenuParent, subMenuLevel);
          });
        });
      };

      /* Handle opening of the mobile menu/hamburger */
      var menuMobileTrigger = function menuMobileTrigger() {
        if (!menuTrigger) {
          return;
        }

        // We add this processed class, otherwise the listener gets readded on
        // resize.
        if (!menuTrigger.classList.contains(classes.processed)) {
          menuTrigger.classList.add(classes.processed);
          menuTrigger.addEventListener('click', function () {
            activeMenuToggle();
            menuMobileToggle();
          });
        }
      };

      /* Handle keyboard navigation on mobile */
      var mobileKeyboard = function mobileKeyboard() {
        var previousLink = menu.querySelectorAll('.menu-level-1 li:first-child > a');
        var previousSubLink = menu.querySelectorAll('.menu-level-2 li:first-child > a');
        var breadcrumbs = menu.querySelectorAll('.menu--breadcrumb > button');
        var previousForYouLink = forYouMenu.querySelector('li:first-child > a');
        // Once we focus on the menu trigger we add the tabbing class to the body.
        menuTrigger.addEventListener('keydown', function (e) {
          if (!body.classList.contains(classes.tabbing) && e.keyCode === 9) {
            body.classList.add(classes.tabbing);
          }
        });

        // We need to detect the first link in the submenu so that when we tab
        // backwards, we tab to the menu breadcrumb.
        previousLink.forEach(function (el) {
          el.addEventListener('keydown', function (e) {
            if (body.classList.contains(classes.mobile) && e.shiftKey && e.keyCode === 9) {
              var breadcrumbButton = menu.querySelector('.menu--breadcrumb-level-0');
              if (breadcrumbButton) {
                breadcrumbButton.focus();
              }
            }
          });
        });

        // Handle first link detection for third level nav.
        previousSubLink.forEach(function (el) {
          el.addEventListener('keydown', function (e) {
            if (body.classList.contains(classes.mobile) && e.shiftKey && e.keyCode === 9) {
              var breadcrumbButton = menu.querySelector('.menu--breadcrumb-level-1');
              if (breadcrumbButton) {
                breadcrumbButton.focus();
              }
            }
          });
        });

        // Handle first link detection for "For You" nav.
        previousForYouLink.addEventListener('keydown', function (e) {
          if (body.classList.contains(classes.mobile) && e.shiftKey && e.keyCode === 9) {
            var breadcrumbButton = menu.querySelector('.menu--breadcrumb-level-0');
            if (breadcrumbButton) {
              breadcrumbButton.focus();
            }
          }
        });

        // Handle breadcrumb tabbing.
        breadcrumbs.forEach(function (el) {
          // Use "Keyup" here bc otherwise we skip a menu item.
          el.addEventListener('keyup', function (e) {
            // This should only fire on the first level, when the second level
            // has no content, and when we're not in the "For You" menu.
            if (e.target.classList.contains('menu--breadcrumb-level-0') && e.target.nextElementSibling.textContent == '' && e.keyCode === 9 && !body.classList.contains(classes.foryou)) {
              menu.querySelector(".".concat(classes.active, " .menu-level-1 li:first-child a")).focus();
            }
            if (e.target.classList.contains('menu--breadcrumb-level-1') && e.keyCode === 9) {
              menu.querySelector(".".concat(classes.active, " .menu-level-2 li:first-child a")).focus();
            }
          });
          el.addEventListener('keyup', function (e) {
            if (e.target.classList.contains('menu--breadcrumb-level-0') && body.classList.contains(classes.foryou)) {
              forYouMenu.querySelector('li:first-child a').focus();
            }
          });
        });
      };

      /* Parent function to handle the "For You" menu on mobile */
      var forYouMobile = function forYouMobile() {
        forYouTrigger.addEventListener('click', function () {
          if (!body.classList.contains(classes.foryou)) {
            body.classList.add(classes.foryou);
            menu.classList.add(classes.submenu);
            mobileBreadcrumb('Resources For You', forYouMenu, forYouMenu);
          } else {
            body.classList.remove(classes.foryou);
            menu.classList.remove(classes.submenu);
          }
        });
      };

      /* Determine the menu type: desktop vs. mobile */
      var menuType = function menuType() {
        if (sizeMq.matches) {
          body.classList.add(classes.desktop);
          body.classList.remove(classes.mobile);
        } else {
          body.classList.remove(classes.desktop);
          body.classList.add(classes.mobile);
        }
      };

      /* Reset menu tabbing when we move the mouse */
      var tabMenuReset = function tabMenuReset() {
        if (body.classList.contains(classes.tabbing)) {
          var activeMenu = menu.querySelector(".".concat(classes.active));
          setTimeout(function () {
            body.classList.remove(classes.open);
            body.classList.remove(classes.tabbing);
            dropdown.style.removeProperty('height');
            removeOpenMenu();
            if (activeMenu) {
              activeMenu.classList.remove(classes.active);
            }
            if (menu.classList.contains(classes.submenu)) {
              menu.classList.remove(classes.submenu);
            }
          }, animationOffset);
        }
      };

      /* Add listeners to handle the keyboard menu reset */
      var tabMenuListeners = function tabMenuListeners() {
        // Reset menu state on mouse move.
        body.addEventListener('mousemove', tabMenuReset);
        // Reset menu state when hitting esc.
        body.addEventListener('keydown', function (e) {
          if (e.keyCode == 27) {
            tabMenuReset();
          }
        });
      };

      /* Function when menu shifts from desktop->mobile or mobile->desktop. */
      var sizeChange = function sizeChange() {
        // Wait for menu to close.
        body.classList.add(classes.resizing);
        setTimeout(function () {
          body.classList.remove(classes.resizing);
          menuType();
          mainMenu();
        }, animationOffset);
      };

      /* Parent function that sets up the menu based on type */
      var mainMenu = function mainMenu() {
        if (body.classList.contains(classes.desktop)) {
          menuDesktop();
          forYouDesktop();
        }
        if (body.classList.contains(classes.mobile)) {
          menuMobileTrigger();
          menuMobileSubmenu();
          mobileKeyboard();
          forYouMobile();
        }
      };
      menuType();
      mainMenu();
      tabMenuListeners();
      sizeMq.addListener(sizeChange);
    }
  };
})(Drupal, once);